var map = {
	"./access-bank-diamond-icon.svg": 39634,
	"./access-bank-icon.svg": 31823,
	"./alat-by-wema-icon.svg": 54847,
	"./ecobank-nigeria-icon.svg": 99985,
	"./fidelity-bank-icon.svg": 93463,
	"./first-bank-of-nigeria-icon.svg": 91693,
	"./first-city-monument-bank-icon.svg": 4189,
	"./guaranty-trust-bank-icon.svg": 82673,
	"./heritage-bank-icon.svg": 26786,
	"./jaiz-bank-icon.svg": 99119,
	"./keystone-bank-icon.svg": 81693,
	"./kuda-bank-icon.svg": 74816,
	"./polaris-bank-icon.svg": 65861,
	"./providus-bank-icon.svg": 22967,
	"./rubies-mfb-icon.svg": 64186,
	"./stanbic-ibtc-bank-icon.svg": 39472,
	"./standard-chartered-bank-icon.svg": 87219,
	"./sterling-bank-icon.svg": 54097,
	"./union-bank-of-nigeria-icon.svg": 53036,
	"./united-bank-for-africa-icon.svg": 53735,
	"./unity-bank-icon.svg": 94778,
	"./vfd-microfinance-bank-limited-icon.svg": 42441,
	"./wema-bank-icon.svg": 35323,
	"./zenith-bank-icon.svg": 13817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4030;